import { DeliveryOption } from '../types';

export function deliveryOptions(container: HTMLDivElement) {
    const deliveryOptions = Array.from(container.querySelectorAll(
        '.js-checkout-delivery-option'
    ) as NodeListOf<HTMLOptionElement>);
    const deliveryLocationRadioButtons = Array.from(document.querySelectorAll(
        '#js-delivery-locations input[type="radio"]'
    ) as NodeListOf<HTMLInputElement>);

    if (deliveryLocationRadioButtons.length === 0 || deliveryOptions.length === 0) {
        return;
    }

    // Order details are saved in the session so that users can navigate away and don't have to re-enter their details
    // On load, disable options which aren't available with the selected delivery location
    window.addEventListener('load', () => {
        const selected = deliveryLocationRadioButtons.find(radioButton => radioButton.checked);
        if (selected === undefined) {
            return;
        }

        limitOptions(getAvailableDeliveryOptions(selected));
    })

    deliveryLocationRadioButtons.forEach((radioButton) => {
        radioButton.addEventListener('click', () => {
            limitOptions(getAvailableDeliveryOptions(radioButton));
        })
    })

    const getAvailableDeliveryOptions = (radioButton: HTMLInputElement): DeliveryOption[] => {
        const json = radioButton.dataset.deliveryOptions;

        if (json === undefined) {
            return [];
        }

        return JSON.parse(json) as DeliveryOption[];
    };

    const limitOptions = (availableDeliveryOptions: DeliveryOption[]) => {
        const ids = availableDeliveryOptions.map(deliveryOption => deliveryOption.id)

        deliveryOptions.forEach(opt => {
            if (ids.includes(parseInt(opt.value, 10))) {
                opt.removeAttribute('disabled');
            } else {
                opt.setAttribute('disabled', 'disabled');
            }
        });

        const selected = deliveryOptions.find(opt => opt.selected);
        if (selected === undefined || !selected.disabled) {
            return;
        }
        // need to select the first option that isn't disabled
        const firstNotDisabled = deliveryOptions.find(opt => !opt.disabled);
        if (firstNotDisabled !== undefined) {
            firstNotDisabled.selected = true;
        }
    }
}
